
// API Reference: https://www.wix.com/corvid/reference
// “Hello, World!” Example: https://www.wix.com/corvid/hello-world

$w.onReady(function () {
	// Write your JavaScript here

	// To select an element by ID use: $w("#elementID")

	$w("#repeater1").forEachItem( ($item, itemData, index) => {

		if ($item("#button30").label.length === 0)
		{
			$item("#button30").hide()
		}else if($item("#button30").label.includes("Coming soon") || $item("#button30").label.includes("On break")) {
			$item("#button30").style.backgroundColor = "gray"
		}else{
		}

		if ($item("#button31").label.length === 0)
		{
			$item("#button31").hide()
		}
	})

	// Click "Preview" to run your code
});